export {
  MatureContentCover,
  MatureContentCoverStyle,
} from './MatureContentCover';
